
export const LOGO_URL = "https://www.pspace-research.com/files/images/logos/nexus_pspace_research_logo.png";
export const SECONDARY_LOGO_URL = "https://www.pspace-research.com/files/images/logos/pspace_research_logo.png";
export const BACKGROUND_IMAGE_URL = "https://www.pspace-research.com/files/images/stock_images/spiral.png";

export const BACKEND = Object.freeze({
    protocol: "https",
    hostname: "nexus-backend-0.pspace-research.com", 
    port: 443, 
    basePath: ""
})
 
export const POLLING = Object.freeze({
    SLOW: 10_000,
    MEDIUM: 1_000,
    FAST: 200,
});

export const VALIDATION = Object.freeze( {
    validationDelay: 400
})


